import React from 'react';

import RectangleToolIcon from 'Assets/RectangleToolIcon';
import PolygonToolIcon from 'Assets/PolygonToolIcon';
import MoveToolIcon from 'Assets/MoveToolIcon';
import PointerToolIcon from 'Assets/PointerToolIcon';
import "Styles/DrawLegend.sass";

type Props = {
    setDraw: (mode: "move" | "rectangle" | "polygon" | "pointer") => void;
    drawMode: "move" | "rectangle" | "polygon" | "pointer";
}

const DrawLegend: React.FC<Props> = ({ setDraw, drawMode }) => {
    const highlightColor = "bg-blue rounded";
    const defaultColor = "";
    const backgroundColor = (checkDrawMode: string) => checkDrawMode === drawMode ? highlightColor : defaultColor;
    const iconSize = "w-[60px] h-[60px]";
    return (
        <div className="legend rounded bg-gray-light w-[200px] h-[100vh] absolute right-0 flex flex-col items-center justify-center p-4 gap-4">
            <button className={`${backgroundColor("pointer")} ${iconSize}`} onClick={() => setDraw("pointer")}>
                <PointerToolIcon />
            </button>
            <button className={`${backgroundColor("move")} ${iconSize}`} onClick={() => setDraw("move")}>
                <MoveToolIcon />
            </button>
            <button className={`${backgroundColor("rectangle")} ${iconSize}`}  onClick={() => setDraw("rectangle")}>
                <RectangleToolIcon />
            </button>
            <button className={`${backgroundColor("polygon")} ${iconSize}`} onClick={() => setDraw("polygon")}>
                <PolygonToolIcon />
            </button>

        </div>
    );
}

export default DrawLegend;